<section class="quotation-parts">
    <div class="title with-divisor">
        <h2>{{ 'buyer.create-quotation.quotation-parts.header.' + (isQuotationWithParts ? 'parts' : 'insumos') + '.title' | translate }}</h2>
        <p>{{ 'buyer.create-quotation.quotation-parts.header.' + (isQuotationWithParts ? 'parts' : 'insumos') + '.subtitle' | translate }}</p>
    </div>

    <form>
        <input-component class="part-name-input" [ngClass]="{ 'is-insumo': !isQuotationWithParts }" [label]="'buyer.create-quotation.quotation-parts.form.label' + (isQuotationWithParts ? '.part-name' : '.insumo')"  [placeholder]="'buyer.create-quotation.quotation-parts.form.placeholder.' + (isQuotationWithParts ? 'part-name' : 'insumo')" [control]="partNameControl" />

        @if (isQuotationWithParts) {
            <input-component class="part-number-input" label="buyer.create-quotation.quotation-parts.form.label.part-number" [control]="partNumberControl" />
        }

        <input-component class="quantity-input" placeholder="0" type="number" [minValue]="1" [maxValue]="999" mask="999" label="buyer.create-quotation.quotation-parts.form.label.quantity" [control]="quantityControl" />

        @if (isQuotationWithParts) {
            <select-component class="type-input" [options]="types" [isMultiselect]="true" label="buyer.create-quotation.quotation-parts.form.label.type" [control]="typeControl" />
            <select-component class="condition-input" [options]="allowsUsedOptions" label="buyer.create-quotation.quotation-parts.form.label.condition" [control]="allowsUsedControl" />
        }

        <button customButton styleType="secondary" iconName="plus" [isLoading]="false" label="buyer.create-quotation.quotation-parts.form.submit" (click)="addPart()"></button>

        @if (!isQuotationWithParts) {
            <div class="footer">
                <i-feather name="info" class="info"></i-feather>
                <p>{{ 'Digite o máximo de características do insumo para facilitar a cotação do mesmo.' | translate }}</p>
            </div>
        }
    </form>

    <div class="parts">
        @if (parts?.length <= 0) {
            <div class="empty-list">
                <h4 class="vazio">{{ 'buyer.create-quotation.quotation-parts.list.empty' + (isQuotationWithParts ? '.with-parts' : '.without-parts') | translate }}</h4>
            </div>
        } @else {
            <div class="header">
                <div class="col-part col-quantity justify-content-center">
                    {{ 'buyer.create-quotation.quotation-parts.list.header.quantity' | translate }}
                </div>
                <div class="col-part col-name" [ngClass]="{ 'is-insumo': !isQuotationWithParts }">
                    {{ 'buyer.create-quotation.quotation-parts.list.header.' + (isQuotationWithParts ? 'parts' : 'insumos') | translate }}
                </div>

                @if (isQuotationWithParts) {
                    <div class="col-part col-part-number">
                        {{ 'buyer.create-quotation.quotation-parts.list.header.part-number' | translate }}
                    </div>
                    <div class="col-part col-type justify-content-end">
                        {{ 'buyer.create-quotation.quotation-parts.list.header.type' | translate }}
                    </div>
                    <div class="col-part col-condition justify-content-end">
                        {{ 'buyer.create-quotation.quotation-parts.list.header.condition' | translate }}
                    </div>
                }

                <div class="col-part col-actions justify-content-end">
                    {{ 'buyer.create-quotation.quotation-parts.list.header.actions' | translate }}
                </div>
            </div>
            <ng-scrollbar>
                @for (part of parts; track part; let partIndex = $index) {
                    <div class="part">
                        <div class="col-part col-quantity justify-content-center">
                            {{part.quantity}}x
                        </div>
                        <div class="col-part col-name" [ngClass]="{ 'is-insumo': !isQuotationWithParts }">
                            <span class="truncate">{{part.partName}}</span>
                        </div>

                        @if (isQuotationWithParts) {
                            <div class="col-part col-part-number">
                                {{part.partNumber}}
                            </div>
                            <div class="col-part col-type justify-content-end">
                                @for (type of part.types; track type) {
                                    <div class="pill-label type">
                                        {{ 'buyer.create-quotation.quotation-parts.part-type.' + type | translate }}
                                    </div>
                                }
                            </div>
                            <div class="col-part col-condition justify-content-end">
                                <div class="pill-label condition">
                                    {{ 'elemento.generico-select.' + (part.allowsUsed ? 'sim' : 'nao') | translate }}
                                </div>
                            </div>
                        }

                        <div class="col-part col-actions justify-content-end">
                            <div class="delete" (click)="removePart(partIndex)">
                                <i-feather name="trash-2"></i-feather>
                            </div>
                        </div>
                    </div>
                }
            </ng-scrollbar>
        }
    </div>
</section>
